import React, { useEffect } from "react";
import {
    FaBolt,
    FaLaptopCode,
    FaRocket,
    FaPaintBrush,
    FaMoneyBillWave,
    FaGlobe
} from "react-icons/fa";
import "./BenefitsFlutter.css";

const BenefitsFlutter = () => {
    useEffect(() => {
        const cards = document.querySelectorAll(".bf-card");

        cards.forEach((card, i) => {
            card.style.opacity = "0";
            card.style.transform = "translateY(60px)";

            setTimeout(() => {
                card.style.transition = "0.8s ease";
                card.style.opacity = "1";
                card.style.transform = "translateY(0)";
            }, i * 150);
        });
    }, []);

    const data = [
        {
            title: "Faster Development",
            desc: "Hot Reload allows instant updates and faster UI building.",
            icon: <FaBolt />,
        },
        {
            title: "Single Codebase",
            desc: "One codebase for Android, iOS, Web & Desktop apps.",
            icon: <FaLaptopCode />,
        },
        {
            title: "High Performance",
            desc: "Near-native performance with smooth 60FPS animations.",
            icon: <FaRocket />,
        },
        {
            title: "Beautiful UI",
            desc: "Custom widgets to create stunning modern interfaces.",
            icon: <FaPaintBrush />,
        },
        {
            title: "Cost Effective",
            desc: "Reduce development cost with cross-platform support.",
            icon: <FaMoneyBillWave />,
        },
        {
            title: "Google Support",
            desc: "Backed by Google with strong ecosystem & updates.",
            icon: <FaGlobe />,
        },
    ];

    return (
        <>
            <section className="bf-section">
                {/* Floating Blobs */}
                <div className="blob b1"></div>
                <div className="blob b2"></div>

                {/* Heading */}
                <div className="bf-heading">
                    <h2 className="bf-title">
                        Benefits of{" "}
                        <span>Flutter</span>
                    </h2>

                    <p className="bf-desc">
                        Flutter helps businesses build powerful, scalable and beautiful
                        applications faster than ever before.
                    </p>
                </div>

                {/* Grid */}
                <div className="bf-grid">
                    {data.map((item, i) => (
                        <div
                            key={i}
                            className="bf-card"
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform =
                                    "translateY(-12px) scale(1.02)";
                                e.currentTarget.style.borderColor = "#E8212A";
                                e.currentTarget.style.boxShadow =
                                    "0 30px 60px rgba(232,33,42,0.15)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "";
                                e.currentTarget.style.borderColor = "#f2f2f2";
                                e.currentTarget.style.boxShadow =
                                    "0 20px 40px rgba(0,0,0,0.05)";
                            }}
                        >
                            {/* glow effect */}
                            <div className="card-glow"></div>

                            <div className="feature-icon">
                                {item.icon}
                            </div>

                            <h3 className="bf-card-title">
                                {item.title}
                            </h3>

                            <p className="bf-card-desc">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>
                <style>

                    {`.feature-icon{
    width:72px;
    height:72px;

    display:flex;
    align-items:center;
    justify-content:center;

   
    border-radius:22px;

    background:none;

    color:#E8212A;
    font-size:30px;

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    transition:all .4s ease;
}

.feature-card:hover .feature-icon{
    transform:
        translateY(-8px)
        rotate(-6deg)
        scale(1.08);

    box-shadow:
        0 25px 60px rgba(232,33,42,.35);
}`}

                </style>
            </section>
        </>
    );
};

export default BenefitsFlutter;